//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const AvailableDateForAppointment = createAsyncThunk(
  "AvailableDateForAppointment",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingAvailableDateForAppointment(""));
      const response = await UsePortalApi(
        `Patient/AvailableDateForAppointment`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
         dispatch(gettingAvailableDateForAppointmentSuccess(response))

      } else {
        dispatch(
          gettingAvailableDateForAppointmentFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingAvailableDateForAppointmentFailed(error));
    }
  }
);
const AvailableDateForAppointmentSlice = createSlice({
  name: "AvailableDateForAppointment",
  initialState: {
    AvailableDateForAppointmentData: null,
    isAvailableDateForAppointmentData: false,
    isAvailableDateForAppointmentError: false,
  },
  reducers: {
    gettingAvailableDateForAppointment: (state, action) => {
      state.AvailableDateForAppointmentData = null;
      state.isAvailableDateForAppointmentData = true;
      state.isAvailableDateForAppointmentError = false;
    },
    gettingAvailableDateForAppointmentSuccess: (state, action) => {
      state.AvailableDateForAppointmentData = action.payload;
      state.isAvailableDateForAppointmentData = false;
      state.isAvailableDateForAppointmentError = false;
    },
    gettingAvailableDateForAppointmentFailed: (state, action) => {
      state.AvailableDateForAppointmentData = null;
      state.isAvailableDateForAppointmentData = false;
      state.isAvailableDateForAppointmentError = true;
    },
    gettingAvailableDateForAppointmentClear: (state, action) => {
      state.AvailableDateForAppointmentData = null;
      state.isAvailableDateForAppointmentData = false;
      state.isAvailableDateForAppointmentError = false;
    },
  },
});
export const {
  gettingAvailableDateForAppointment,
  gettingAvailableDateForAppointmentSuccess,
  gettingAvailableDateForAppointmentFailed,
  gettingAvailableDateForAppointmentClear,
} = AvailableDateForAppointmentSlice.actions;
export default AvailableDateForAppointmentSlice.reducer;
